import { render, staticRenderFns } from "./ErrorSnackbarCatcher.vue?vue&type=template&id=e763163e"
import script from "./ErrorSnackbarCatcher.vue?vue&type=script&lang=js"
export * from "./ErrorSnackbarCatcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports